import React from 'react'

import Trackable from './Trackable'
import MetaTags from './MetaTags'
import HeroBase from '../components/HeroBase'
import PrivacyContent from '../components/PrivacyContent'

const title = 'Intento Privacy Policy'
const description =
    'Access many AI vendors via a single integration with up to 23x better performance/price efficiency by using the right model for your specific case.'
const metatags = {
    title,
    description,
    og: {
        title,
        description,
        url: 'https://inten.to/privacy',
    },
    twitter: {
        title,
        description,
    },
}

const Support = () => (
    <Trackable page="privacy">
        <MetaTags tags={metatags} />
        <HeroBase center>
            <h1 className="hero__title h1">Privacy Policy</h1>
        </HeroBase>
        <PrivacyContent />
    </Trackable>
)

export default Support



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/containers/Privacy.jsx